module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc12-066d01da925f58efd922d4216e1baf2f.jpg";